import React from 'react'

import { styled } from '@linaria/react'
import { FormattedMessage } from 'react-intl'
import { useDispatch } from 'react-redux'

import { ClipPathOuter } from 'components/block/Profile/ProfileMain/profileMain.styled'
import { MainLayout } from 'components/designSystem/layout/MainLayout/MainLayout'
import promoLimit from 'components/designSystem/svg/promo-limit.svg'
import { searchPath } from 'components/page/Search/Search.paths'
import { push } from 'functions/router'

export const PromoLimit = () => {
  const dispatch = useDispatch()
  const handlePrimaryButtonClick = () => dispatch(push(searchPath))

  return (
    <Parent>
      <MainLayout
        title={
          <FormattedMessage
            id="app.rating.limit.title"
            defaultMessage="Ты достиг лимита"
          />
        }
        description={
          <FormattedMessage
            id="app.rating.limit.description"
            defaultMessage="На сегодня голоса закончились, но ты можешь продолжить в Поиске"
          />
        }
        icon={<img src={promoLimit} width={200} height={200} />}
        backButtonVisible={false}
        onPrimaryButtonClick={handlePrimaryButtonClick}
        primaryButtonText={
          <FormattedMessage
            id="go_to_search.button.title"
            defaultMessage="Перейти в Поиск"
          />
        }
        secondaryButtonColor="accent"
        increasePaddingBottom={true}
        noBorder={true}
        wrapperStyle={{
          background: 'var(--background-surface-2)',
        }}
      />
    </Parent>
  )
}

const Parent = styled(ClipPathOuter)`
  width: 100%;
  background-color: var(--background-page);
`
